import { render, staticRenderFns } from "./invoiceRecognition.vue?vue&type=template&id=7765ab62&"
import script from "./invoiceRecognition.vue?vue&type=script&lang=js&"
export * from "./invoiceRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports